import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
// Hot-path functions deployed to us-east1 to use that region's CPU quota pool.
// Use this when calling: stripeWebhook (HTTP, not callable), inboundEmail (HTTP),
// chatWithAssistant, chatWithAssistantStream.
export const functionsEast = getFunctions(app, "us-east1");
// Customer-payment + invoice sign/decline callables in us-west1.
export const functionsWest = getFunctions(app, "us-west1");

// Customer-facing Express API (single Cloud Run service in us-west1).
// All public payment + sign/decline endpoints are hosted under one service.
const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
export const CUSTOMER_API_BASE = `https://us-east1-${projectId}.cloudfunctions.net/customerApi`;
export async function callCustomerApi(path, body) {
  const res = await fetch(`${CUSTOMER_API_BASE}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body || {}),
  });
  let payload = null;
  try { payload = await res.json(); } catch { /* non-json response */ }
  if (!res.ok) {
    const err = new Error((payload && payload.error) || `HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return payload;
}